import * as types from '../utils/mutation-types.js'

const state = {
  disp_data: [],
  flg_list: {}
}

const mutations = {
  [types.POSITION_DISP_DATA] (state, data) {
    state.disp_data = data
  },
  [types.POSITION_FLG_LIST] (state, data) {
    state.flg_list = data
  }
}

const getters = {
  getDispData: state => state.disp_data
}

const actions = {
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/positioning.js